let ipcRenderer = null;

try {
    if (typeof window !== 'undefined' && typeof window.require === 'function') {
        const electron = window.require('electron');
        if (electron && electron.ipcRenderer && typeof electron.ipcRenderer.invoke === 'function') {
            ipcRenderer = electron.ipcRenderer;
        }
    }
} catch (error) {
    ipcRenderer = null;
}

export const isWarehouseApp = () => ipcRenderer !== null;

export const warehouseCredentials = {
    list() {
        return ipcRenderer.invoke('warehouse:credentials:list');
    },
    get(email) {
        return ipcRenderer.invoke('warehouse:credentials:get', {email});
    },
    save(account) {
        return ipcRenderer.invoke('warehouse:credentials:save', account);
    },
    remove(email) {
        return ipcRenderer.invoke('warehouse:credentials:remove', {email});
    },
};
